// 菜单页的配置数据
// key 对应router导航的配置
// value 对应展示的菜单名称
// sub 对应子菜单项
export default {
    data: [
        {
            key: 'index',
            value: '首页'
        },
        {
            key: 'advantage',
            value: '平台优势',
            sub: [
                {
                    key: 'flow',
                    value: '品质流量',
                },
                {
                    key: 'ai',
                    value: 'AI赋能',
                },
                {
                    key: 'content',
                    value: '内容场景',
                },
                {
                    key: 'dimension',
                    value: '多维服务',
                }
            ]
        },
        {
            key: 'case',
            value: '成功案例'
        },
        {
            key: 'flow_to_cash',
            value: '流量变现'
        },
        {
            key: 'news',
            value: '新闻资讯'
        },
        {
            key: 'about',
            value: '关于我们'
        },
        {
            key: 'all',
            value: '≡',
            reactiveSub: [
                {
                    key: 'index',
                    value: '首页'
                },
                {
                    key: 'flow',
                    value: '品质流量',
                },
                {
                    key: 'ai',
                    value: 'AI赋能',
                },
                {
                    key: 'content',
                    value: '内容场景',
                },
                {
                    key: 'dimension',
                    value: '多维服务',
                },
                {
                    key: 'case',
                    value: '成功案例'
                },
                {
                    key: 'flow_to_cash',
                    value: '流量变现'
                },
                {
                    key: 'news',
                    value: '新闻资讯'
                },
                {
                    key: 'about',
                    value: '关于我们'
                }
            ]
        },
    ]
}


// WEBPACK FOOTER //
// ./src/data/tab.js